export function useLocaleManager() {
    const { locale, setLocale, availableLocales } = useI18n()
    const projectStore = useProjectStore()

    // user preference that persists across navigation (SSR-safe)
    const preferredLocale = useState('preferred-locale', () => null)

    const applyLocale = async () => {
        // FIX: extract the actual locale string
        const projectLang = projectStore.selectedProject?.defaultLanguage

		//alert(projectLang)

        // priority: user choice → project → english
        const target = preferredLocale.value || projectLang || 'en'

        // avoid unnecessary updates
        if (locale.value !== target) {
            if (!availableLocales || availableLocales.includes(target)) {
                await setLocale(target)
            } else {
                console.warn(`Locale '${target}' is not in availableLocales`, availableLocales)
            }
        }
    }

    // react to project changes
    watch(
        () => projectStore.selectedProject,
        () => applyLocale()
    )

    // user-triggered change (buttons in header)
    const changeLocale = async (code) => {
        preferredLocale.value = code
        await setLocale(code)
    }

    return {
        locale,
        preferredLocale,
        changeLocale,
        applyLocale,
    }
}
